var RTMConst = {
					HOST_LOGOUT: 1,
					IS_SESSION_STARTED: 100,
					BECOME_BROADCASTER: 200,
					SEND_HANDRAISE: 201,
					SEND_EMOJI: 202,
					OPEN_MIC: 203,
					TURN_MIC_OFF: 204,
					START_SESSION_RECORDING: 205,
					BPM_HEART_RATE: 206,
					JOINED: 208,
					BECOME_AUDIENCE: 209,
					SWITCH_VIDEO_BROADCAST: 210,
					START_SCRIPT: 211,
					STOP_SCRIPT: 212,
					PAUSE_SCRIPT: 213,
					NEXT_SCRIPT: 214,
					PREVIOUS_SCRIPT: 215,
					WELCOME: 216,
					SHOW_SESSION_RECORDING_ICON: 217,
					EJECT_PARTICIPANT: 218,
					SHOW_EMOJIS: 219,
					SESSION_STARTED: 222,
					SHOW_SESSION_SCRIPT: 223,
					PARTICIPANT_LIST: 224,
					EXPAND_COLLAPSE_STREAM: 226,
					CAMERA_MIC_PERMISSION: 230,
					MUTE_UNMUTE_LOCAL_STREAM: 235,
					OPEN_PLAYLIST: 236,
					SWITCH_CAMERA: 237,
					SESSION_RECORDING: 238,
					SYNC_SCRIPT: 240,
					START_SESSION: 241,
					MUTE_UNMUTE_ALL: 242,
					SHOW_SESSION_DETAILS: 243,
					UP_ARROW: 244,
					DOWN_ARROW: 245,
					LEFT_ARROW: 246,
					RIGHT_ARROW: 247,
					OK_BUTTON: 248,
					BACK_BUTTON: 249,
					SELECT_ONSCREEN_PARTICIPANT_SCREEN: 250,
					ZOOM_PARTICIPANT: 251,
					HANDRAISE_DROPDOWN_LIST: 252,
					ZOOM_LOCAL_STREAM: 253,
					MAX_ON_SCREEN: 254,
					HOST_SETTINGS: 255,
					REMOTE_WINE_SCORE: 274,
					REMOTE_VIDEO_LIST: 275,
					REMOTE_PARTICIPANT_CAMERA_SETTING: 276,
					REMOTE_ZOOM_HOST: 277,
					REMOTE_PARTICIPANT_MIC_SETTING: 278,
					REMOTE_ACTIVITY_LIST: 279,
					SHOW_NO_SCRIPT_EMOJIS: 256,
					UNMUTE_ALL: 290,
					MUTE_ALL: 291,
					POOR_NETWORK: 296,
					UNMUTE_BROADCASTER_OTHER_PARTICIPANT: 300,
					MUTE_BROADCASTER_OTHER_PARTICIPANT: 301,
					SETTINGS: 302,
					SWITCH_HOST_PARTICIPANT: 303,
					SESSION_COMPLETED: 306,
					ROOM_SETUP_TURN_OFF: 307,
					CHAT: 308,
					CHAT_SYNC: 309,
					CALCULATE_DIMENSIONS: 311,
					ADD_AS_AUDIENCE: 1000,
					PLAY_PLAYLIST: 501,
					STOP_PLAYLIST: 502,
					HOST_JOINED: 503,
					HOST_OFFLINE: 504,
					SYNC_MANUAL: 505,
					SYNC_SESSION_RECORDING: 508,
					SYNC_SESSION_PLAYLIST: 509,
					REMOTE_ADD_ALERT:258,
					REMOTE_DISMISS_NOTE:259,
					REMOTE_RAISE_HAND: 262,
					REMOTE_EMOJIES_OPEN: 265,
					REMOTE_ZOOM_LOCAL: 266,
					REMOTE_PARTICIPANT_LIST: 267,
					REMOTE_SPEAKER: 260,
	                REMOTE_VOLUME_CHANGE_FOR_INSTRUCTOR: 288,
	                REMOTE_VOLUME_CHANGE_FOR_MUSIC: 289,
					PARTICIPANT_REMOTE_BACK: 268,
					PARTICIPANT_REMOTE_ARROW_UP: 269,
					PARTICIPANT_REMOTE_ARROW_DOWN: 270,
					PARTICIPANT_REMOTE_ARROW_LEFT: 271,
					PARTICIPANT_REMOTE_ARROW_RIGHT: 272,
					PARTICIPANT_REMOTE_OK: 273,
					TURN_MIC_ON: 510,
					PARTICIPANT_MUTED_SELF:511,
					PARTICIPANT_UNMUTED_SELF:512,
					HOST_UNPINNED_PARTICIPANT: 513,
					SYNC_WHEN_PAUSE_ACTIVITY: 514,
					MEMBER_ONLINE: 515,
				}



export default RTMConst;					
